import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { EiqDateRangePicker, EiqSelect } from 'eiq-storybook';

import Svg from 'src/components/Svg';
import Button from 'src/components/Button';
import s from 'src/components/SurveyDashboard/SurveyDashboard.styles';
import { SurveyStatisticsPropTypes } from 'src/components/SurveyDashboard/propTypes';
import { SURVEY_DASHBOARD_DATA, SURVEY_RESPONSES_BY_VALIDITY } from 'src/components/SurveyDashboard/constants';

const SurveyDashboardOverview = ({ 
  surveySummary, 
  onFilterChange, 
  from, 
  to, 
  setFrom, 
  setTo, 
  hide, 
  isPublic,
  selectedOptionValue,
  setSelectedOptionValue
}) => {
  const { t } = useTranslation();
  const excludeInvalidResponse = selectedOptionValue?.value === 'exclude_invalid_responses';

  const convertToReadableTime = (timeInSeconds) => {
    let sec = timeInSeconds;
    const hours = Math.floor( ( sec %= 86400 ) / 3600 );
    const minutes = Math.floor( ( sec %= 3600 ) / 60 );
    const seconds = Number.parseFloat( sec % 60 ).toFixed( 0 );

    if ( hours || minutes || seconds ) {
      let readableTime = hours ? `${hours} hour ` : "";
      readableTime = minutes ? readableTime.concat(`${minutes} min `) : "";
      readableTime = readableTime.concat(`${seconds} sec`);
      return readableTime;
    }

    return `${sec} sec`;
  };

  const displayContent = (data) => {
    if(data.text === 'AVERAGE_TIME') {
      return convertToReadableTime(surveySummary[data.key]);
    }
    if(data.text === 'COMPLETION_RATE') {
      return `${surveySummary[data.key]}%`;
    }

    return surveySummary[data.key];
  };

  const svgIcon = (data) => {
    if (data.key === 'totalResponses') {
      return <Svg className={s.TotalResponseIconStyle.svg} name="menu"/>;
    }

    return '';
  };

  const onResetFilter = (e) => {
    e.preventDefault();
    if (from || to) {
      setFrom(null);
      setTo(null);
      onFilterChange({
        selectedFromDate: null,
        selectedToDate: null,
        excludeInvalidResponse,
      });
    }
  };

  const applyClass = () => {
    if (hide) {
      if (!isPublic) {
        return s.Classes["ml-auto"];
      }

      return `${s.Classes["ml-auto"]} ${s.Classes["mt-40"]}`;
    } 

    return '';
  };
  return (
    <Fragment>
      <s.Row>
        { !hide && (
          <s.Left>
            <s.QuestionText space-around-none grey-text>Summary</s.QuestionText>
          </s.Left> 
        )}  
        <s.Right col-gap className={applyClass()}>
          <div>
            <EiqSelect
              name="filter"
              touched={true}
              backspaceRemovesValue={false}
              isClearable={false}
              wrapperClass=''
              showLabel={false}
              hasChips
              onChange={(name, option) => {
                console.log("name, option", name, option);
                setSelectedOptionValue(option);
                onFilterChange({ 
                  selectedFromDate: from, 
                  selectedToDate: to,
                  excludeInvalidResponse: option.value === 'exclude_invalid_responses',
                });
              }}
              options={SURVEY_RESPONSES_BY_VALIDITY}
              placeholder=''
              value={selectedOptionValue}
            />
            <EiqDateRangePicker
              dateRangeEnd={to ? moment(to).toDate() : null}
              dateRangeStart={from ? moment(from).toDate() : null}
              placeholderText="Select date range..."
              handleChange={(selectedFromDate, selectedToDate, e) => {
                setFrom(selectedFromDate);
                setTo(selectedToDate);
                onFilterChange({ selectedFromDate, selectedToDate, excludeInvalidResponse });
              }}
              allLabel="All"
              allOnClick={(e) => {
                setTo(null);
                setFrom(null);
              }}
              showAll
              dateRangeButtons={{
                showLastYear: true,
                showLastMonth: true,
                showLast365Days: true,
              }}
              maxDate={new Date()}
            />
          </div>
          <s.ResetButtonWrapper>
            <Button ghost onClick={(e) => onResetFilter(e)} red sm>
              {t('RESET')}
            </Button>
          </s.ResetButtonWrapper>
        </s.Right>
      </s.Row>
      { !hide && <s.ContentWrapper>
          {SURVEY_DASHBOARD_DATA.map((d)=>{
            return (
              <s.ContentDiv key={d.id}>
                <s.Content>{displayContent(d)}</s.Content>
                <s.Label>
                  {svgIcon(d)}
                  {t(d.text)}
                </s.Label>
              </s.ContentDiv>)}
            )
          }
        </s.ContentWrapper>
      }
    </Fragment>
  );
};

SurveyDashboardOverview.defaultProps = SurveyStatisticsPropTypes;

export default React.memo(SurveyDashboardOverview);

